export const BUTTON_TYPES = {
    filled: 'filled',
    outlined: 'outlined',
    tab: 'tab',
};
